import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const NIF_LETTERS = 'TRWAGMYFPDXBNJZSQVHLCKE';
const NIE_PREFIXES = { X: 0, Y: 1, Z: 2 };

export function nifNieValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    let number, letter;

    if (/^[XYZ]\d{7}[A-Z]$/.test(value)) {
      number = value.slice(1, -1);
      letter = value.slice(-1);
      number = NIE_PREFIXES[value[0] as keyof typeof NIE_PREFIXES] + number;
    } else if (/^\d{8}[A-Z]$/.test(value)) {
      number = value.slice(0, -1);
      letter = value.slice(-1);
    } else {
      return { invalidFormat: true };
    }

    const validLetter = NIF_LETTERS[parseInt(number, 10) % 23];
    return validLetter === letter ? null : { invalidNifNie: true };
  };
}
